import produce from 'immer';

import { GADimension, TrackingCategory } from '@swf/core/enums';
import type { TrackingContextValue } from '@swf/core/providers/TrackingContext';
import type { CrmZoneClick } from '@swf/generated/analytics/crmZoneClick';
import { crmZoneClick } from '@swf/generated/analytics/crmZoneClick';
import { crmZoneView } from '@swf/generated/analytics/crmZoneView';
import { crmZone } from '@swf/generated/analytics/entities';

import { GAEvent } from './utils';

export const crmEntity = (zoneName: string, html: string) => {
  try {
    const tag = html.match('<!--data-analytics-tag="(.+?)"-->');
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const { packageId, packageName } = JSON.parse(tag![1]);
    return crmZone({ zoneName, packageId: parseInt(packageId, 10), packageName });
  } catch (err) {
    // do nothing
  }
};

export const CRMClicked = (
  context: TrackingContextValue,
  zoneId: string,
  html: string,
  action: CrmZoneClick['action']
) => {
  const crmZone = crmEntity(zoneId, html);

  if (crmZone) {
    const { packageId, packageName } = crmZone.data;

    GAEvent(
      { action: 'Zone Clicked', label: zoneId, value: packageId },
      { category: TrackingCategory.CRM },
      { [GADimension.UIElementName]: packageName }
    );

    crmZoneClick(
      { action },
      produce(context, (draft) => {
        draft.entities = draft.entities || [];
        draft.entities.push(crmZone);
      })
    );
  }
};

export const CRMViewed = (context: TrackingContextValue, zoneId: string, html: string) => {
  const crmZone = crmEntity(zoneId, html);

  if (crmZone) {
    const { packageId, packageName } = crmZone.data;

    GAEvent(
      { action: 'Zone Viewed', label: zoneId, value: packageId },
      { category: TrackingCategory.CRM },
      { [GADimension.UIElementName]: packageName }
    );

    crmZoneView(
      {},
      produce(context, (draft) => {
        draft.entities = draft.entities || [];
        draft.entities.push(crmZone);
      })
    );
  }
};
